module.exports = __webpack_public_path__ + "static/apple-icon-120x120.ce60fb8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/favicon/apple-icon-120x120.png
// module id = 545
// module chunks = 168707334958949